'use strict'

import {initializeApp} from 'firebase/app'
import {
  addDoc,
  collection,
  getDocs,
  getFirestore,
} from 'firebase/firestore';
import { initializeAnalytics } from 'firebase/analytics'

export default class Firebase{
  constructor(){
    const firebaseConfig = {
      apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
      authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
      projectId: process.env.VUE_APP_FIREBASE_PROJ_ID,
      storageBucket: process.env.VUE_APP_FIREBASE_STRG_BCKT,
      messagingSenderId: process.env.VUE_APP_FIREBASE_MSSG_SENDER_ID,
      appId: process.env.VUE_APP_FIREBASE_APP_ID,
      measurementId: process.env.VUE_APP_FIREBASE_MSR_ID
    }
    
    this.app = initializeApp(firebaseConfig);
    this.store = getFirestore(this.app);
  }

  initAnalytics(){
    this.analytics =initializeAnalytics(this.app);
  }

  /**
   * @param {Object} form form items to register Github repogitory
   * @return {Promise<void>}
   */
  async addDocument(form){
    try {
      const docRef = await addDoc(collection(this.store, "users"), {
        company: form.company,
        job: form.job,
        family: form.family,
        first: form.first,
        mail: form.mail,
        url: form.url,
      });
      console.log("Document written with ID: ", docRef.id);
    } catch (e) {
      console.error("Error adding document: ", e);
    }
  }

  /**
   * @return {Promise<void>}
   */
  async getDocument(){
    const querySnapshot = await getDocs(collection(this.store, "users"));
    querySnapshot.forEach((doc) => {
      console.dir(doc);
    });
  }
}